import {Model, ModelMixin} from '../common/model.class';
import {Address} from '../common/values/address.class';
import {ContactInfo} from './contact-info.model';
import {BirthInfo} from './birth-info.model';
import {DriverLicenseInfo} from './driver-license-info.model';
import {PracticeSpecialtiesInfo} from './practice-specialties-info.model';
import {WorkInfo} from './work-info.model';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class Profile extends ModelMixin() implements Model<Profile> {

    TYPE = Profile;

    address: Address = new Address();
    contact: ContactInfo = new ContactInfo();
    birth: BirthInfo = new BirthInfo();
    driverLicense: DriverLicenseInfo = new DriverLicenseInfo();
    ssn: string;
    npi: string;
    languages: string[] = [];
    practiceSpecialties: PracticeSpecialtiesInfo = new PracticeSpecialtiesInfo();
    work: WorkInfo = new WorkInfo();

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.contact) jsonData.contact = new ContactInfo(jsonData.contact);
        if (jsonData.birth) jsonData.birth = new BirthInfo(jsonData.birth);
        if (jsonData.driverLicense) jsonData.driverLicense = new DriverLicenseInfo(jsonData.driverLicense);
        if (jsonData.practiceSpecialties) jsonData.practiceSpecialties = new PracticeSpecialtiesInfo(jsonData.practiceSpecialties);
        if (jsonData.work) jsonData.work = new WorkInfo(jsonData.work);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/profile/profile.model.ts